export default __webpack_public_path__ + "static/media/health.007f42a1.svg";